import React from 'react';
import user_chart from "../assets/imgs/user_chart.png";

const UserStat = () => {
  return (
    <div className="bg-primary-blue-500 w-full rounded-md px-[40px] py-9">
        <div className='w-full h-full pb-20'>
        <img src={user_chart} width={121} height={121} alt='stat' />
        </div>
        <div className='w-full h-[1px] bg-secondary-n-0 mb-6' ></div>
        <div className='flex flex-col gap-4'>
            <div className='flex justify-between items-center'>
                <p className='text-mdregular text-white'>Male User</p>
                <p className='text-mdregular text-white'>40%</p>
            </div>
             <div className='flex justify-between items-center'>
                <p className='text-mdregular text-white'>Female User</p>
                <p className='text-mdregular text-white'>60%</p>
            </div>
        </div>
    </div>
  )
}

export default UserStat